<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500"
    >
        <v-card class="pb-5">
            <v-toolbar flat class="white--text" color="secondary">
                <v-toolbar-title>
                    {{ title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pt-5 black--text pre-line">
                {{ message ? message : 'Are you sure you want to take this action.' }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    outlined
                    @click="closeWithAction(false)"
                >
                    {{ cancelBtnText? cancelBtnText : 'Disagree' }}
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    @click="closeWithAction(true)"
                >
                    {{ confirmBtnText? confirmBtnText : 'Agree' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: false
        },
        confirmBtnText: {
            type: String,
            required: false
        },
        cancelBtnText: {
            type: String,
            required: false
        },
        confirmData: {
            type: Object,
            required: false
        }
    },
    data() {
        return {

        }
    },
    methods: {
        closeWithAction(action) {
            this.$emit('confirm:action', action, this.confirmData)
        }
    }
}
</script>

<style scoped>
.pre-line {
    white-space: pre-line;
}
</style>